import { render, staticRenderFns } from "./ContentLogTable.vue?vue&type=template&id=39f671f5&"
import script from "./ContentLogTable.vue?vue&type=script&lang=js&"
export * from "./ContentLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports